import {useCallback, useMemo, useState} from 'react';
import {GestureResponderEvent, ScrollViewProps} from 'react-native';
import {ScrollViewMapProps} from '../types';

export interface UseScrollViewMapReturnValue {
  scrollViewProps: Pick<ScrollViewProps, 'scrollEnabled' | 'onTouchStart'>;
  mapProps: ScrollViewMapProps;
}
export function useScrollViewMap(): UseScrollViewMapReturnValue {
  const [scrollEnabled, setScrollEnabled] = useState(true);
  const [isMapTouching, setIsMapTouching] = useState(false);

  const onTouchStart = useCallback(() => {
    setIsMapTouching(true);
    setScrollEnabled(false);
  }, []);

  const onTouchEnd = useCallback(() => {
    setIsMapTouching(false);
  }, []);

  const onTouchCancel = useCallback(() => {
    setIsMapTouching(false);
    setScrollEnabled(true);
  }, []);

  const onTouchScrollViewStart = useCallback((e: GestureResponderEvent) => {
    e.stopPropagation();
    setScrollEnabled(true);
    setIsMapTouching(false);
  }, []);

  const scrollViewProps = useMemo(
    () => ({
      scrollEnabled: scrollEnabled && !isMapTouching,
      onTouchStart: onTouchScrollViewStart,
    }),
    [scrollEnabled, isMapTouching, onTouchScrollViewStart],
  );

  const mapProps = useMemo(
    () => ({
      scrollGesturesEnabled: !scrollEnabled,
      onTouchStart,
      onTouchEnd,
      onTouchCancel,
    }),
    [onTouchStart, onTouchEnd, onTouchCancel, scrollEnabled],
  );

  return {
    scrollViewProps,
    mapProps,
  };
}
